export default "<c-i class=\"icon\">{{ icon }}</c-i>\r\n\r\n<div class=\"text\">\r\n    <ng-content></ng-content>\r\n</div>"